import { ReactNode } from 'react';

import { ReviewRating } from '@/src/components/review/ReviewDetailed/ReviewHeader/ReviewRating';

type IReviewHeaderProps = {
  title: ReactNode;
  noteIos: number;
  noteAndroid: number;
  linkToAppStore: string;
  linkToPlayStore: string;
};

export const ReviewHeader = ({
  title,
  noteIos,
  noteAndroid,
  linkToPlayStore,
  linkToAppStore,
}: IReviewHeaderProps) => {
  // TODO TERENCE: 1rem de margin pour les providers apple/google au top de leur case
  return (
    <div className={'max-w-xl px-4'}>
      <div className={'mb-1 text-4xl font-semibold lg:mb-4 lg:text-6xl'}>
        {title}
      </div>
      <div className={'grid grid-cols-2 items-center'}>
        <ReviewRating
          note={noteIos}
          image={'/static/images/apple-store.svg'}
          platform={'App Store'}
          width={119.66}
          link={linkToAppStore}
          alt={'App Store'}
        />
        <ReviewRating
          note={noteAndroid}
          image={'/static/images/google-play.svg'}
          platform={'Google Play Store'}
          width={135}
          link={linkToPlayStore}
          alt={'Google Play Store'}
        />
      </div>
    </div>
  );
};
